/* eslint-disable import/prefer-default-export */
import fetch from '@api/fetchers';

export const submitLiveClassReview = (review) =>
  fetch('v1/uplus/live-class-review/', {
    requestType: 'POST',
    body: {
      live_class_uid: review.live_class_uid,
      is_liked: review.is_liked,
      review_text: review.review_text,
      suggestions: review.suggestions
    }
  });

export const sendWatched = (uid) =>
  fetch(`v1/post/${uid}/track/`, {
    requestType: 'POST'
  });

export const sendWatchedPrevious = (uid) =>
  fetch(`v1/uplus/classes/${uid}/watched/`, {
    requestType: 'POST'
  });

export const notifyForUpcomingClass = ({ programmeUid, enroll }) =>
  fetch(`v2/uplus/programmes/${programmeUid}/save/`, {
    requestType: 'POST',
    body: {
      enroll
    }
  });

export const enrollToProgramme = (courseId) =>
  fetch(`v2/uplus/programmes/${courseId}/enroll/`, {
    requestType: 'POST'
  });

export const followEducator = ({ userName }) =>
  fetch(`v1/user/${userName}/follow/`, {
    requestType: 'POST'
  });

export const unFollowEducator = ({ userName }) =>
  fetch(`v1/user/${userName}/unfollow/`, {
    requestType: 'POST'
  });
